import { createFileRoute } from '@tanstack/react-router'

import { GeneralContent } from '@/discover/components/DiscoverAll/DiscoverAll'

export const Route = createFileRoute('/_learning/discover/channels/view')({
  component: RouteComponent,
})

function RouteComponent() {
  return <GeneralContent />
}
